import { Component, OnInit } from '@angular/core';
import { ToastService } from '../service/toast/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {
  toastMessage: string | null = null;
  toastType: 'success' | 'error' = 'success';
  statusCode: number | null = null;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.toastService.toast$.subscribe((toast) => {
      this.toastMessage = toast.message;
      this.toastType = toast.type;
      this.statusCode = toast.statusCode || null; 

      setTimeout(() => {
        this.clearToast();
      }, 4000); // Auto hide after 4 seconds
    });
  }

  clearToast() {
    this.toastMessage = null;
  }
}
